<template>
    <div :class="classes">
        <header class="notifications__header">
            <h2 class="notifications__title">Notificações</h2>
            <div class="notifications__actions" v-if="unreadCount">
                <a
                    class="notifications__actions__action"
                    href="#"
                    @click.prevent="$emit('read-all')"
                >Marcar tudo como lido</a>
            </div>
        </header>
        <div v-if="loading" class="notifications__spinner">
            <v-progress-circular
                indeterminate
                color="primary"
            ></v-progress-circular>
        </div>
        <div v-if="!list.length && !loading" class="notifications__empty-list">
            <i class="material-icons notifications__empty-list__icon">
                wb_sunny
            </i>
            <span
                 class="notifications__empty-list__text"
            >Nenhuma notificação por enquanto</span>
        </div>
        <div v-if="list.length" class="notifications__list">
            <fluke-notification-item
                v-for="(notification, index) of listPaging"
                :key="notification.id"
                :notification="notification"
                :is-last="(+index + 1) % limit === 0"
                @click="n => $emit('click', n)"
            ></fluke-notification-item>
            <div v-if="list.length" class="notifications__actions">
                <button
                    class="fluke-btn"
                    v-if="page < pages"
                    @click.prevent="showMore"
                >Ver mais</button>
                <span v-else>Não há mais notificações</span>
            </div>
        </div>
    </div>
</template>

<script>
import NotificationItem from './NotificationItem.vue'
export default {
    name: 'notifications',
    components: {
        'fluke-notification-item': NotificationItem
    },
    props: {
        opened: {
            type: Boolean,
            default: false
        },
        list: {
            type: Array,
            default: []
        },
        loading: {
            type: Boolean,
            default: false
        },
        unreadCount: {
            type: Number,
            default: 0
        }
    },
    computed: {
        classes () {
            return {
                'notifications': true,
                'notifications--opened': this.opened,
                'notifications--loading': this.loading,
            }
        },
        listPaging () {
            const end = this.page * this.limit
            return this.list.slice(0, end)
        }
    },
    data () {
        return {
            page: 1,
            limit: 10,
            pages: 0,
        }
    },
    methods: {
        showMore () {
            ++this.page
        },
    },
    watch: {
        list: {
            handler (value) {
                const pages = Math.ceil(value.length / this.limit)
                this.pages = pages
            },
        },
    },
}
</script>

<style lang="scss">
.notifications {
    @extend %default-borderRadius;
    @extend %default-shadow;
    position: absolute;
    z-index: 100;
    top: 40px;
    right: 20px;
    left: 0px;
    background: white;
    height: calc(100vh - 90px);
    padding: 20px;
    display: none;
    flex-direction: column;
    @media (min-width: $mobile-size) {
        left: auto;
        width: 400px;
    }
    &--opened {
        display: flex;
    }
    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    &__title {
        font-size: 22px;
        font-weight: 500;
    }
    &__actions {
        &__action {
            color: inherit;
        }
    }
    &__list {
        margin: 20px 0 0 0;
        flex-grow: 1;
        overflow-x: auto;
    }
    &__empty-list {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        &__icon {
            font-size: 100px !important;
            color: #FEC402;
        }
        &__text {
            font-size: 18px;
            text-align: center;
            margin-top: 20px;
            font-weight: 500;
            max-width: 50%;
        }
    }
    &__spinner {
        text-align: center;
        flex-grow: 1;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    &__actions {
        margin: 20px 0 10px 0;
        text-align: center;
    }
}
</style>
